﻿import axios from "axios";
import { api } from "@/lib/api";
export interface WorkerTransferResult {
  operation_id: string;
  radnik: string;
  gradiliste: string;
  brigada: string | null;
  od: string;
  prethodni_zadnji_dan: string | null;
  undo_until: string;
  ceka_odobrenje: boolean;
}
export interface WorkerTransferInput {
  operation_id: string;
  radnik_id: string;
  trenutni_raspored_id: string | null;
  gradiliste_id: string;
  brigada_id: string | null;
  od: string;
  radi_na_oba_danas: boolean;
}
export const workerTransfers = {
  move: async (data: WorkerTransferInput) =>
    (await api.post<WorkerTransferResult>("/worker-transfers", data)).data,
  undo: async (id: string) => {
    await api.post(`/worker-transfers/${id}/undo`);
  },
};
export function transferError(error: unknown): string {
  const detail = axios.isAxiosError(error)
    ? error.response?.data?.detail
    : undefined;
  if (
    typeof detail === "string" &&
    !/raspored|vrijedi_|članstv|sql|constraint|traceback/i.test(detail)
  )
    return detail;
  return "Promjena nije potvrđena. Osvježite stranicu i provjerite gdje je radnik prije ponovnog pokušaja.";
}
